import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import '@fontsource-variable/inter';
import './styles/tokens.css';
// The chart palette. Beside the design tokens rather than inside a screen: two
// screens draw series now, and it was validated as one set — see viz.css.
import './styles/viz.css';
import './styles/base.css';
import './styles/ui.css';
import { initTheme } from './lib/theme';
import { captureHandoff } from './auth/handoff';
import { captureOauthReturn } from './oauth/oauthReturn';
import { App } from './App';

// FIRST executable statements: park ?oauth_error and the dashboard's one-time
// ?code, and strip both from the address bar before the router (created inside
// <App/>) snapshots the location. The code is single-use — leaving it in the
// URL would put a live credential in history and in anything the user copies.
captureOauthReturn(window.location);
captureHandoff(window.location);
initTheme(window.location.pathname);

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
